import { GiroWebappError } from 'model/error';
import { action } from 'typesafe-actions';
import { FundDocumentsDownloadTypes } from './types';

export const fundDocumentsDownloadRequest = (documentId: string) => action(FundDocumentsDownloadTypes.FUND_DOCUMENTS_DOWNLOAD_REQUEST, documentId);
export const fundDocumentsDownloadSuccess = (data: Uint8Array) => action(FundDocumentsDownloadTypes.FUND_DOCUMENTS_DOWNLOAD_SUCCESS, data);
export const fundDocumentsDownloadError = (error: GiroWebappError) => action(FundDocumentsDownloadTypes.FUND_DOCUMENTS_DOWNLOAD_ERROR, error);
export const fundDocumentsDownloadReset = () => action(FundDocumentsDownloadTypes.FUND_DOCUMENTS_DOWNLOAD_RESET_STATE);
